import React from "react"
import { Button } from "react-bootstrap"
import StandardList from "../../common/listing/list.component"
import { FormattedMessage } from "react-intl"
import OrderAttempt from "../../state/price-list/OrderAttempt"
import { dismissOrderAttempt, retryOrderAttempt } from "../../state/price-list/orderAttemptActions"
import { connect, ConnectedProps } from "react-redux"
import { FormattedDate, FormattedNumber } from "react-intl"

type OwnProps = {
    priceListId: string
    orderAttempts: OrderAttempt[]
}
const OrderAttemptListingComponent = (props: Props) => {
    return (
        <StandardList
            smallLine={true}
            headers={createHeaders()}
            rows={props.orderAttempts.map(createRow(props))}
            className="px-0 pt-2"
        />
    )
}

const createHeaders = () => {
    return [
        <FormattedMessage
            key="order_attempt_listing.contact"
            id="order_attempt_listing.contact"
            defaultMessage="Contact"
        />,
        <FormattedMessage
            key="order_attempt_listing.attempt_date"
            id="order_attempt_listing.attempt_date"
            defaultMessage="Attempt Date"
        />,
        <FormattedMessage
            key="order_attempt_listing.status"
            id="order_attempt_listing.status"
            defaultMessage="Status"
        />,
        <FormattedMessage
            key="order_attempt_listing.amount"
            id="order_attempt_listing.amount"
            defaultMessage="Amount"
        />,
        "",
    ]
}

const createRow = (props: Props) => (orderAttempt: OrderAttempt) => {
    const orderAttemptRetry = "order-attempt-retry-" + orderAttempt.getId()
    const orderAttemptDismiss = "order-attempt-dismiss-" + orderAttempt.getId()

    return [
        orderAttempt.getContactName(),
        <FormattedDate
            key={0}
            year="numeric"
            month="long"
            day="numeric"
            value={new Date(orderAttempt.getAttemptDate())}/>,
        <span key={1} className="badge badge-danger">
            <FormattedMessage
                id="order_attempt.failed"
                defaultMessage="Failed"
            />
        </span>,
        <FormattedNumber
            key={2}
            value={orderAttempt.getAmount()}
            style={"currency"}
            currency={orderAttempt.getCurrency()}
        />,
        <>
            <Button onClick={() => props.retryOrderAttempt(orderAttempt.getId(), orderAttemptRetry)}
                className="btn-sm mr-2">
                <FormattedMessage
                    id="order_attempt.retry"
                    defaultMessage="Retry"
                />
            </Button>
            <Button
                onClick={() =>
                    props.dismissOrderAttempt(orderAttempt.getId(), orderAttemptDismiss)
                }
                className="btn-secondary btn-sm">
                <FormattedMessage
                    id="order_attempt.dismiss"
                    defaultMessage="Dismiss"
                />
            </Button>
        </>,
    ]
}

const mapDispatch = {dismissOrderAttempt, retryOrderAttempt}
const mapState = (state, props: OwnProps) => ({...props})

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(OrderAttemptListingComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/OrderAttemptListingComponent.tsx